import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

const url = `coberturas/estoque-seguranca/localidade`;

export const buscarListaCoberturas = async (params) => {
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.coberturas;
  }

  logout();
}

export const salvarCoberturas = async (params) => {
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarListaProdutosPorCurvas = async (params) => {
  const {data, status} = await api.get(`${url}/curvas/produtos`, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}

export const aplicarCoberturas = async (params) => {
  const {data, status} = await api.put(`${url}/aplicar`, params, {headers: iniciarRequisicao()}).catch(logout);

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
